module.exports = __webpack_public_path__ + "e7630258ea69a28679a489186b091d34.png";